import { ReactNode } from 'react'

import { Box, BoxProps, Heading } from '@chakra-ui/react'

import { FeatureIcon } from '@/entities/feature'

interface GroupTitleProps extends BoxProps {
	name: string
	iconName?: string
	children?: ReactNode
}

/**
 * Component for show group title with icon and tooltip
 *
 * @author Ivan Shchedrovskyi
 */
export const GroupTitle = ({
	name,
	iconName,
	children,
	...props
}: GroupTitleProps) => {
	return (
		<Heading
			size="md"
			as="span"
			display="inline-flex"
			columnGap="0.5rem"
			alignItems="center"
			color="gray.500"
			{...props}
		>
			{iconName && <FeatureIcon groupIconName={iconName} />}
			<Box display="inline">{name}</Box>
			{children}
		</Heading>
	)
}
